module.exports = __webpack_public_path__ + "img/3-low.44c9f7fa.jpg";